import { StreamName } from "../StreamName"
import { isNumber, isObject } from "lodash-es";
import { useEffect, useMemo, useState } from "react"
import { toUnitValStrWithFormat } from "../utils"
import { useGetVariableUnit } from "@/pages/Project/hooks/useDimUnits"
import { ManualCell } from "../ManualCell"

export interface NozzleSim {
  index: number
  unitId: string
  key: string
  eta: {val: number, type: number}
  flow: number
}

interface NozzleTableProps {
  data: NozzleSim[]
  onChange?: (val: number[]) => void
  readonly?: boolean
  onDelete?: (index: number) => void
}

export function NozzleTable(props: NozzleTableProps) {
  const {data, onChange, readonly = false, onDelete} = props
  const initVal = data.map(item => item.eta?.val ?? item.eta)
  const [value, setValue] = useState(initVal)
  const getUnitEntityByCode = useGetVariableUnit()

  useEffect(() => {
    const newVal = data.map(item => item.eta?.val ?? item.eta)
    setValue(newVal)
  }, [data])

  const updateVar = (val: number, index) => {
    const allVals = [...value]
    allVals[index] = val
    setValue(allVals)
    onChange?.(allVals as number[])
  }

  const flowUnitEntry = useMemo(() => {
    return getUnitEntityByCode('MOL_F')
  }, [getUnitEntityByCode])

  const splitRatioUnitEntry = useMemo(() => {
    return getUnitEntityByCode('PF')
  }, [getUnitEntityByCode])

  const renderFlow = (value) => {
    const isManual = isObject(value)
    const val = isManual ? value.val : value
    const renderVal = isNumber(val) ? toUnitValStrWithFormat(val as number, flowUnitEntry): val as number
    if (isManual) {
      return <span className="manualInputRow">{renderVal}</span>
    }
    
    return renderVal
  }

  return <div>
    <table style={{width: '100%'}} className="bordered-table break-word-table table-mt">
      <thead>
        <tr>
          <th scope="col" style={{width: 60}}>Port #</th>
          <th scope="col">Stream</th>
          <th scope="col">{`Flow[${flowUnitEntry?.unit?.code || '-'}]`}</th>
          <th scope="col" style={{width: 140}}>Split Ratio[{splitRatioUnitEntry?.unit?.code || '-'}]</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => {
          return <tr>
          <td>{item.index}</td>
          <td>{item.unitId ? <StreamName unitId={item.unitId}/> : '-'}</td>
          <td>{renderFlow(item.flow)}</td>
          <td>
            <ManualCell readonly={readonly} cellData={item.eta}
            onChange={(val) => updateVar(val, index)}
            onDelete={() => onDelete?.(index)}
            dimCode="PF"
            unitEntiry={splitRatioUnitEntry}
            />
          </td>
        </tr>
        })}
        
      </tbody>
    </table>
  </div>
}
